import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'adminConsole.credentialRecovery.title',
    defaultMessage: 'Invio procedura recupero credenziali',
    description: 'Title of recovery credential dialog',
  },
  labelCredentialToRecoveryRadioGroup: {
    id: 'adminConsole.credentialRecovery.labelCredentialToRecoveryRadioGroup',
    defaultMessage: 'Credenziali da recuperare:',
    description: 'Label for radio group to chosen credential to recovery',
  },
  labelUserCodeRadio: {
    id: 'adminConsole.credentialRecovery.labelUserCodeRadio',
    defaultMessage: 'Username',
    description: 'Label for user code radio button',
  },
  labelPasswordRadio: {
    id: 'adminConsole.credentialRecovery.labelPasswordRadio',
    defaultMessage: 'Password',
    description: 'Label for password radio button',
  },
  labelEmailRadio: {
    id: 'adminConsole.credentialRecovery.labelEmailRadio',
    defaultMessage: 'Email',
    description: 'Label for email radio button',
  },
  labelSMSRadio: {
    id: 'adminConsole.credentialRecovery.labelSMSRadio',
    defaultMessage: 'SMS',
    description: 'Label for SMS radio button',
  },
  labelChannelRadioGroup: {
    id: 'adminConsole.credentialRecovery.labelChannelRadioGroup',
    defaultMessage: 'Inviare procedura via:',
    description:
      'Label for radio group to send the recovery credential procedure by channel selected',
  },
});
